import $ from 'jquery';
import PaymentCalculatorForm from './payment-calculator'

//  Finance/Lease Toggling on Small Calc Form

let financeInfoBtn = $('#show-finance-info');
let leaseInfoBtn = $('#show-lease-info');

let financeInfo = $('.finance-info');
let leaseInfo = $('.lease-info');

function handleInfoShow(div) {
  // .payment-info covers the payment panes, which do not carry .calculator-info.
  $('.calculator-info, .payment-info').removeClass('is-active');
  div.addClass('is-active');
}

financeInfoBtn.on('click', function () {
  handleInfoShow(financeInfo);
});

leaseInfoBtn.on('click', function () {
  handleInfoShow(leaseInfo);
});

// Frequency Toggle Styling

$('.vdp-page').on('click', '.frequency-btn-label', function () {
  $('.frequency-btn-label').removeClass('is-active');
  $(this).addClass('is-active');
});

// VDP Calc Form
let paymentCalculatorForm = new PaymentCalculatorForm('js-calc-small-form');

$('.print-elements').on('click', function() {
  paymentCalculatorForm.printAll(['lease']);
});
